module.exports = __webpack_public_path__ + "static/img/peitu-5.20d03c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/eInvoice/peitu-5.png
// module id = 523
// module chunks = 12